'use strict';
// import  tns  from 'tiny-slider/src/tiny-slider';

import * as dom from '../lib/dom.js';

function Slider() {
  const bannerSlide = document.querySelector('.c-slider__banner-slider-content');
  const bannerJsEnable = document.querySelector('.js-slider__banner');
  const sliderJsEl =  document.querySelector('.js-slider__banner');
  const displayWidth = window.innerWidth;
  if (bannerJsEnable) {
    if (displayWidth <= 1024) {
        const Slider_podcast = tns({
            container: '.js-slider__banner',
            items: 1,
            slideBy: 1,
            // autoplay: true,
            nav: true,
            controls: false,
            navContainer: '.c-podcast-content__dots-banner-slider',
            autoplayButtonOutput: false
        });
    } else {
        const Slider_podcast = tns({
            container: '.js-slider__banner',
            items: 1,
            slideBy: 1,
            autoplay: true,
            nav: true,
            controls: false,
            swipeAngle: false,
            loop: false,
            navContainer: '.c-podcast-content__dots-banner-slider',
            autoplayButtonOutput: false,
            axis: 'vertical'
        });
    }
  }

  const bannerBackground = document.querySelector('.c-banner-podcast-content');
  dom.removeClass(bannerSlide, 'no-js');
  dom.addClass(sliderJsEl, 'slider-loaded');

}

export default function() {
  window.addEventListener('turbolinks:load', function() {
    const sliderJsEl =  document.querySelector('.js-slider__banner');
    if (sliderJsEl) {
      if (!dom.hasClass(sliderJsEl, 'slider-loaded')) {
          Slider();
      }
    }
    

  });
};
